import { ButtonIcon } from '@mage-ui/components';
import { Icon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import {
  buttonIcon,
  buttonIconIcon,
  focus,
  icon as iconRecipe,
  link,
  linkBtn,
} from '@mage-ui/styled-system/recipes';
import Link from 'next/link';

export const LinkBtn = ({ href, text, icon, ...props }) => {
  return (
    <Link href={href} className={focus()} {...props}>
      <span className={cx(linkBtn().link, link({ size: 's' }))}>
        {text}
        <Icon
          aria-hidden='true'
          name='chevron_right'
          classNames={iconRecipe({ size: 'm' })}
        />
      </span>
      <ButtonIcon
        aria-hidden='true'
        label={text}
        icon={icon}
        classNames={{
          root: cx(
            buttonIcon({
              color: 'primary',
            }),
            linkBtn().btn,
          ),
          icon: buttonIconIcon(),
        }}
      />
    </Link>
  );
};
